// The two fascial-work offerings (mirrors the Personal Training dropdowns on
// the Services page). Shown as collapsible cards on the Discover Fascia page.

export const fascialWorkItems = [
  {
    title: 'Human Garage Fascial Maneuvers',
    content: {
      heading: 'Fascial Maneuvers at Breathing Room',
      subheading: 'with Jill | Grounded Wellness',
      intro: "If your body has been whispering…or shouting…\ntightness, stress, fatigue, pain, or simply a sense that something feels \"off\"…\nthis space is for you.\n\nJoin us at Breathing Room Bermuda for guided Fascial Maneuvers sessions designed to help you release tension, reconnect with your body, and move with greater ease.\n\nThis is not about pushing harder.\nIt's about listening deeper.",
      sections: [
        {
          title: 'What Are Fascial Maneuvers?',
          text: "Fascial Maneuvers, developed by Human Garage in 2020, are gentle, intentional movement sequences designed to work with the body's fascial system.\n\nRather than focusing on muscles alone, we explore:",
          bullets: [
            'slow, mindful movement',
            'rotation and counter-rotation',
            'breath-led release',
            'supportive body positioning',
          ],
          afterBullets: 'These movements help unwind tension patterns held in the body—physically, emotionally, and neurologically.',
          benefitsIntro: 'In practice, they can:',
          benefits: [
            'reduce stress and physical tension quickly, allowing the body to naturally reorganize and realign',
            'improve mobility, circulation, and overall fluid movement',
            'support the release of stored emotional patterns while creating a quieter, more settled mind',
            'regulate the nervous system, helping the body shift out of stress and into repair',
            'support hormonal balance by lowering stress load (including cortisol) and improving overall system communication',
            'create space for the body to heal and restore over time',
            "and some sort of magic that's difficult to describe unless you practice and experience it",
          ],
        },
        {
          title: 'What Is Fascia?',
          text: "Fascia is the body's connective web—\na continuous, intelligent network that wraps around and through everything:",
          inlineList: ['muscles', 'bones', 'organs', 'nerves', 'blood vessels'],
          afterList: "…but more than structure, it's communication.\n\nFascia responds to stress, posture, injury, and even emotional experience.\nIt holds patterns. It adapts. It remembers.\n\nWhen fascia becomes restricted, we often feel it as:\ntightness, discomfort, reduced mobility, or fatigue.\n\nWhen it begins to release…\nthe body often feels lighter, freer, and more fluid.",
        },
        {
          title: 'What to Wear',
          text: 'Come as you are—just comfortably.\n\nThink:',
          bullets: [
            'leggings or stretch pants',
            'loose, breathable clothing',
            'anything you can move and relax in',
          ],
          afterBullets: 'You may occasionally need access to your knees, so clothing that allows for that is helpful.\n\nNo special gear needed.\nChairs are available if you prefer a seated practice.',
        },
      ],
    },
  },
  {
    title: 'Hands-on Fascial Body Work',
    content: {
      heading: 'Body / Emotion Alignment',
      subheading: 'Hands-on Fascial Body Work with Jill',
      intro: 'A body/emotion alignment session is designed to release stuck and stored emotions and stored stress from the entire body — muscle and fascia tissues, the nervous system, organs, and meridian lines.',
      sections: [
        {
          title: 'What to Expect',
          text: "This is a hands-on session that resembles acupressure, and muscle/fascia and organ release.\n\nIt is thorough and fairly swift as we move energy out through the entire body — quickly, before it can settle back in — before sweeping it out.\n\nThis is not a relaxation session.\nIt is an active session for both of us.",
        },
        {
          title: 'Pricing',
          text: 'The initial session includes extra time for intake and history gathering.',
          bullets: [
            'Initial session — $125 for roughly 60–75 minutes (history is obtained)',
            'Follow-up sessions — $125 for 60 minutes',
            'Extended time — option to carry on at a rate of $100/hour',
          ],
        },
        {
          title: "Sensitivities & Who It's For",
          text: 'Because of the nature of the work, those in chronic pain or in a delicate state must declare sensitivities prior to the session commencing.\n\nThere are gentler methods to call upon in all situations.\n\nThis is a conversation — between you, your body, your emotions, and myself as practitioner.',
        },
      ],
      bookingLink: {
        label: 'Ready to book? Reserve your session',
        url: 'https://www.wellnessliving.com/rs/appointment-new/breathing_room-rws2se?dtu_redirect=2026-05-03+23%3A28%3A31&id_class_tab=3&id_mode=1&s_id=GEsFIv',
      },
    },
  },
];
